import { useRef, useEffect } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css';

function Map() {
  const mapRef = useRef()
  const mapContainerRef = useRef()

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoibjgxOHBlIiwiYSI6ImNtbmtqeGt5aTEwZTkycW9haWhxOHl5bzUifQ.kGkvAv5i-myxfYizyqDLXw'
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [-123.36555, 48.42838],
      zoom: 12,
      scrollZoom: false,
      attributionControl: false,
      style: 'mapbox://styles/mapbox/light-v11'
    });

    mapRef.current.addControl(new mapboxgl.NavigationControl({ showZoom: true}));

    const popup = new mapboxgl.Popup().setText(
      'Victoria City Hall'
    );

    new mapboxgl.Marker({ color: 'red' })
      .setLngLat([-123.36555, 48.42838])
      .setPopup(popup)
      .addTo(mapRef.current);

    return () => {
      mapRef.current.remove()
    }
  }, [])

  return (
    <>
      <div style={{ width: '100%', height: '400px'}} id='map-container' ref={mapContainerRef}/>
    </>
  )
}

export default Map;